var map = {
	"./cn.json": "94cd",
	"./de.json": "7707",
	"./en.json": "ef66",
	"./es.json": "323b",
	"./fr.json": "0c67",
	"./jp.json": "ab4d",
	"./pl.json": "64ed",
	"./pt-br.json": "1e3a",
	"./tr.json": "28ff",
	"./tw.json": "7f9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caf4";